import { IContactsState } from '../interfaces/ContactsState';

type WithContactsState = {
  ContactsSlice: IContactsState;
};
export const ContactsStateSelector = (
  state: WithContactsState,
): IContactsState => state.ContactsSlice;
